module.exports = __webpack_public_path__ + "img/b3-2.4ad36cd.png";